import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import Card from "../../components/Cards/Card";
import KpiCard from "../../components/KPI/KpiCard";
import CardWrapper from "../../components/LayoutCardsWrapper/CardWrapper";
import LayoutCardsWrapper from "../../components/LayoutCardsWrapper/LayoutCardsWrapper";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useQlik } from "../../context/Qlik";
import { useSelections } from "../../context/Selections";

function DashboardDesktop({ app, config }) {
  const { selections } = useSelections();
  const { setSwitchOnDemand } = useQlik();
  const { container } = config.dashboard;
  const [vCrescFaturamento, setVCrescFaturamento] = useState("");

  const [selectPeriodo, setSelectPeriodo] = useState("");
  const [selectTipoSelecao, setSelectTipoSelecao] = useState("");

  const initializeField = () => {
    app.variable.getContent("vCrescFaturamento", (reply) => {
      const data = reply.qContent.qString;
      setVCrescFaturamento(data);
    });
  };

  useEffect(() => {
    if (app) {
      initializeField();
    }
  }, [selections]);

  useEffect(() => {
    setSwitchOnDemand(false);
  });

  return (
    <div className="app dashboard">
      <div className="appContent">
        <LayoutCardsWrapper>
          {/* KPIs */}
          <div
            style={{ width: "100%", paddingInline: "10px", paddingTop: "8px" }}
          ></div>

          <CardWrapper customStyle={{ height: "15%", textAlign: "center" }}>
            {container[0].cards.slice(1).map((card, index) => {
              return (
                <KpiCard
                  key={index}
                  app={app}
                  KPITitle={{
                    id: card.title.id,
                    hardTitle: card.title.hardTitle,
                  }}
                  percentageId={card.nativeObject.percentageId}
                  valueId={card.nativeObject.valueId}
                  customStyle={{ height: "100%" }}
                  isMobile={false}
                  selectedCheck={selectPeriodo}
                  tooltip={card.title.tooltip}
                ></KpiCard>
              );
            })}
          </CardWrapper>

          {/* YTD */}
          {/* <div style={{ width: "100%", paddingInline: "10px" }}>
            <ComboHeader
              classStyle="title-combo-container"
              reference={{ title: { hard: container[1].name } }}
            ></ComboHeader>
          </div> */}

          <CardWrapper
            customStyle={{
              paddingBottom: "0px",
              height: "85%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            {/* Mapa de vendas */}
            <div
              style={{
                width: "48%",
                height: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Card
                header={{
                  tooltip: container[3].cards[0].title.tooltip,
                  hardTitle: container[3].cards[0].title.hardTitle,
                  hardSubtitle: container[3].cards[0].subtitle.hardSubtitle,
                }}
                expandable
                style={{ width: "100%" }}
              >
                <NativeObject
                  app={app}
                  key={container[3].cards[0].nativeObject.valueId}
                  reference={{ id: container[3].cards[0].nativeObject.id }}
                  style={{ width: "100%", height: "92%" }}
                />
                <NativeObject
                  app={app}
                  reference={{ id: "bKVTPBk" }}
                  style={{
                    width: "100%",
                    height: "8%",
                    color: "4B81D0",
                  }}
                />
              </Card>
            </div>

            <CardWrapper
              customStyle={{
                paddingBottom: "0px",
                paddingRight: "0px",
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <CardWrapper
                customStyle={{
                  paddingRight: "0px",
                  height: "70%",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {/* Atingimento Meta */}
                <Card
                  header={{
                    tooltip: container[1].cards[0].title.tooltip,
                    hardTitle: container[1].cards[0].title.hardTitle,
                  }}
                  style={{ width: "30%", height: "100%" }}
                >
                  <NativeObject
                    app={app}
                    key={container[1].cards[0].nativeObject.valueId}
                    reference={{ id: container[1].cards[0].nativeObject.id }}
                  />
                </Card>

                {/* Projeção */}
                <div
                  style={{
                    width: "70%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <Card
                    header={{
                      tooltip: container[1].cards[1].title.tooltip,
                      hardTitle: container[1].cards[1].title.hardTitle,
                      hardSubtitle: container[1].cards[1].subtitle.hardSubtitle,
                    }}
                    expandable
                    exportTable
                    exportTableId={container[1].cards[1].nativeObject.id}
                    app={app}
                    style={{ width: "100%", height: "100%" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        height: "100%",
                        width: "100%",
                      }}
                    >
                      <NativeObject
                        app={app}
                        key={container[1].cards[1].nativeObject.valueId}
                        reference={{
                          id: container[1].cards[1].nativeObject.id,
                        }}
                      />
                      <span
                        app={app}
                        style={{
                          fontWeight: "bold",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        {vCrescFaturamento}
                      </span>
                    </div>
                  </Card>
                </div>
              </CardWrapper>

              {/* Linha Temporal */}
              <Card
                header={{
                  tooltip: container[2].cards[0].title.tooltip,
                  hardTitle: container[2].cards[0].title.hardTitle,
                  hardSubtitle: container[2].cards[0].subtitle.hardSubtitle,
                }}
                expandable
                exportTable
                exportTableId={container[2].cards[0].nativeObject.id}
                app={app}
                style={{ height: "100%" }}
              >
                <NativeObject
                  app={app}
                  key={container[2].cards[0].nativeObject.valueId}
                  reference={{ id: container[2].cards[0].nativeObject.id }}
                />
              </Card>
            </CardWrapper>
          </CardWrapper>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

DashboardDesktop.defaultProps = {
  app: null,
  config: {},
};

DashboardDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default DashboardDesktop;
